import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import useSupercluster from 'use-supercluster';
import {
  useRouter,
} from "/lib/component/util";
import "./mapStyles.css";

// eslint-disable-next-line react/prop-types
const Marker = ({ children }) => children;

// eslint-disable-next-line react/prop-types
const SingleMarker = () => {
  return (
    <div 
    // onClick={onClick()}
    // onKeyPress={(event) => {
    //   if (event.key === "Enter") {
    //     onClick()
    //   }
    // }}
    role="button"
    tabIndex={0} 
    style={{
    height: '10px',
    width: '10px',
    backgroundColor: '#9C2948',
    borderRadius: '50%',
  }}></div>
  )
};
const darkTheme = [
  { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
  {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
  },
  {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
  },
  {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }]
  },
  {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }]
  },
  {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }]
  },
  {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }]
  },
  {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }]
  },
  {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }]
  },
  {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }]
  },
  {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }]
  },
  {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }]
  },
  {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
  },
  {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }]
  },
  {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }]
  },
  {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }]
  }
];

// eslint-disable-next-line react/prop-types
const MapChart = ({ points }) => {
  const mapRef  = React.useRef();
  const router = useRouter()
   // get map bounds
   const [bounds, setBounds] = useState(null);
   const [zoom, setZoom] = useState(4);

   const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 20 }
  });
  
  // console.log(clusters[0]?.geometry.coordinates[1])
  const defaultProps = {
    center: {
      lat: supercluster?.points[0]?.geometry.coordinates[1] || clusters[0]?.geometry.coordinates[1] || points?.length === 0 && 39.5,
      lng: supercluster?.points[0]?.geometry.coordinates[0] || clusters[0]?.geometry.coordinates[0] || points?.length === 0 && -98.35,
    },
    zoom: 6,
  };

  function redirectToEntity(namespace, name) {
    router.history.push(`/n/${namespace}/entities/${name}`)
    setTimeout(() => {
    }, 1)
  }

  return (
    // Important! Always set the container height explicitly
    clusters.length > 0 || supercluster ?
      (<div style={{ height: '425px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyAhItMVXYG0TYDFCo1Lf3kDtxRmiZRJrWM' }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        options={{ styles: darkTheme }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map;
        }}
        onChange={({ zoom, bounds }) => {
          setZoom(zoom);
          setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat
          ]);
        }}
      >
        {clusters.map(cluster => {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const {
            cluster: isCluster,
            point_count: pointCount
          } = cluster.properties;

          if (isCluster) {
            return (
              <Marker
                key={`cluster-${cluster.id}`}
                lat={latitude}
                lng={longitude}
              >
                <div
                  role="button"
                  tabIndex={0} // makes the div focusable
                  className="cluster-marker"
                  style={{
                    width: `${10 + (pointCount / points?.length || 1) * 20}px`,
                    height: `${10 + (pointCount / points?.length || 1) * 20}px`
                  }}
                  onClick={() => {
                    const expansionZoom = Math.min(
                      supercluster.getClusterExpansionZoom(cluster.id),
                      20
                    );
                    // if (expansionZoom === zoom) {
                    // }
                    mapRef.current.setZoom(expansionZoom);
                    mapRef.current.panTo({ lat: latitude, lng: longitude });
                  }}
                  // to make it accessible, handle key press event (e.g., when "Enter" is pressed)
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      const expansionZoom = Math.min(
                        supercluster.getClusterExpansionZoom(cluster.id),
                        20
                      );
                      mapRef.current.setZoom(expansionZoom);
                      mapRef.current.panTo({ lat: latitude, lng: longitude });
                    }
                  }}
                >
                  {pointCount}
                </div>
              </Marker>
            );
          }

          return (
            <Marker
              key={`terminal-${cluster.properties.name}`}
              lat={latitude}
              lng={longitude}
            >
              <button className="terminal-marker" onClick={() => redirectToEntity(cluster.properties.namespace, cluster.properties.name) }>
                <SingleMarker/>
              </button>
            </Marker>
          );
        })}
      </GoogleMapReact>
      </div>)
    : null
  );
};

export default MapChart;